import React from "react";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { loginRequest } from "../auth/authConfig";
import {
  InteractionStatus,
  IPublicClientApplication,
} from "@azure/msal-browser";
import Button from "@mui/material/Button";

const SigninButton: React.FC = () => {
  const { instance, inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();

  const handleLogin = async (instance: IPublicClientApplication) => {
    if (!isAuthenticated && inProgress === InteractionStatus.None) {
      await instance.loginRedirect(loginRequest);
    }
  };

  return (
    <Button
      variant="contained"
      size="large"
      onClick={() => handleLogin(instance)}
    >
      Sign In with Microsoft bro
    </Button>
  );
};

export default SigninButton;
